













































import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { FETCH_LIST, SET_LIST_PAGE } from '../store';
import CompensationTable from '../components/CompensationTable.vue';
import MonthPicker from '@/components/form/MonthPicker.vue';
import CompensationStateSelect from '../components/CompensationStateSelect.vue';
import { CompensationList } from '@/modules/compensation/types';
import { ApiResponse } from '@/components/types';
import { SearchableMixin } from '@/views/mixin';
import { routeToLocation } from '@/router';

const CompensationStore = namespace('compensation');

@Component({
  components: {
    CompensationStateSelect,
    CompensationTable,
    MonthPicker
  }
})
export default class Compensations extends SearchableMixin {
  @CompensationStore.State('list') list!: CompensationList;
  @CompensationStore.Mutation(SET_LIST_PAGE) setPage!: (page: number) => void;
  @CompensationStore.Action(FETCH_LIST) fetch!: () => Promise<ApiResponse>;

  loading: boolean = false;
  rowsPerPage: number = 10;

  get month(): string | undefined {
    return this.$route.query['month'] as string;
  }

  set month(month: string | undefined) {
    if (!month) {
      const { month, ...query } = this.$route.query;
      this.$router.push(routeToLocation({ ...this.$route, query: { ...query } })).catch(() => {});
      return;
    }

    this.$router.push(routeToLocation({ ...this.$route, query: { ...this.$route.query, month } })).catch(() => {});
  }

  get state(): string | undefined {
    return this.$route.query['state'] as string;
  }

  set state(state: string | undefined) {
    if (!state) {
      const { state, ...query } = this.$route.query;
      this.$router.push(routeToLocation({ ...this.$route, query: { ...query } })).catch(() => {});
      return;
    }

    this.$router.push(routeToLocation({ ...this.$route, query: { ...this.$route.query, state } })).catch(() => {});
  }

  async created() {
    this.loading = true;

    await this.fetch();

    this.loading = false;
  }
}
